import { InlineFormatBar } from 'components/InlineFormatBar/InlineFormatBar'
import { InlineFormatDivider } from 'components/InlineFormatBar/components/InlineFormatDivider/InlineFormatDivider'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { observer } from 'mobx-react-lite'
import store from 'redux/store'
import { type TextInlineFormatBarProps } from '../../Types'
import { ClearFormattingInlineFormatButton } from '../Buttons/ClearFormattingInlineFormatButton'
import { CommentInlineFormatButton } from '../Buttons/CommentInlineFormatButton/CommentInlineFormatButton'
import { DeleteInlineFormatButton } from '../Buttons/DeleteInlineFormatButton'
import { InlineTextColorButton } from '../Buttons/InlineTextColorButton/InlineTextColorButton'
import { TodoInlineFormatButton } from '../Buttons/TodoInlineFormatButton/TodoInlineFormatButton'

export const TableOfContentsEditModeFormatBar = observer(
  ({ article, layer, queryClient, docStore, view, runItemKey }: TextInlineFormatBarProps) => {
    const { auth, unregisteredUser } = store.getState()
    const { isMobile } = useResponsiveDesign()
    const { access_map } = article

    const hideTaskButton =
      (!auth && !unregisteredUser.user) ||
      (!!access_map && !access_map.has_edit_access && access_map.edit_access_through_sharing_link) ||
      !layer.is_main

    if (!view.editable) return null

    return (
      <InlineFormatBar>
        <InlineTextColorButton view={view} />
        <ClearFormattingInlineFormatButton view={view} />
        <InlineFormatDivider />
        <CommentInlineFormatButton
          hide={isMobile}
          view={view}
          runItemKey={runItemKey}
          layerId={layer.id}
          queryClient={queryClient}
          docStore={docStore ?? null}
        />
        <TodoInlineFormatButton
          hide={hideTaskButton}
          view={view}
          queryClient={queryClient}
          docStore={docStore ?? null}
        />
        <InlineFormatDivider />
        <DeleteInlineFormatButton view={view} />
      </InlineFormatBar>
    )
  },
)
